import { useState } from "react";
import { Formik } from "formik";
import { Divider, Grid, TextField, FormLabel } from "@mui/material";
import { Modal } from "../../../components/common/Modal/Modal";
import { ModalHeader } from "../../../components/common/Modal/ModalHeader";
import { ModalBody } from "../../../components/common/Modal/ModalBody";
import { ModalFooter } from "../../../components/common/Modal/ModalFooter";
import { useTypeProductStore } from "../../../hooks/useTypeProductStore";

type Values = {
    id: number,
    code: string,
    name: string,
    description: string,
    status: string,
}

const states = [
    {name: 'Activo', value: '1'},
    {name: 'Desactivo', value: '0'},
]

export const TypeProductsModal: React.FC<any> = (props): JSX.Element | any => {

    const { open, closeModal, typeSelected, listTypes, clearState } = props;

    const { action, createTypeProduct, editTypeProduct } = useTypeProductStore();

    const [loading, setLoading] = useState(false);
    const [data, setData] = useState<Values>({
        id: typeSelected ? typeSelected.id :'',
        code: typeSelected ? typeSelected.code :'',
        name: typeSelected ? typeSelected.name :'',
        description: typeSelected ? typeSelected.description :'',
        status: typeSelected ? typeSelected.status :'1',
    });

    const validateForm = (values) => {
        let errors:any = {};
        if(!values.code) errors.code = "el campo es requerido";
        if(!values.name) errors.name = "el campo es requerido";
        return errors;
    }

    const onSubmit = async(values)  => {
        setLoading(true);

        if(typeSelected){
            const response:any = await editTypeProduct(typeSelected.id, values);
            if(response){
                listTypes && listTypes();
                closeModal && closeModal();
                clearState && clearState();
                setLoading(false);
            }else{
                setLoading(false);
                return false;
            }
        }else{
            const response:any = await createTypeProduct(values);
            if(response){
                listTypes && listTypes();
                closeModal && closeModal();
                clearState && clearState();
                setLoading(false);
            }else{
                setLoading(false);
                return false;
            }
        }
    }

    return (
        <Modal open={open} handleClose={closeModal} disableEscapeKeyDown disableBackdropClick handle size="md" paperprops={{style: { position: 'absolute', right: -30, borderRadius: 20, animation: 'slide-in 0.3s ease-out', maxHeight: '100%', height: '100vh' }}}>
            <ModalHeader
                text={
                    action == 'edit' ? 'Editar tipo de producto' : (action == 'add' ? 'Nuevo tipo de producto' : 'Detalle del tipo de producto')
                }
                className='positionElements'
                onCancel={closeModal}
                clearState={clearState}
            >
            </ModalHeader>
            <ModalBody>
                <Formik initialValues={data} enableReinitialize validate={ (values) => validateForm(values) } onSubmit={onSubmit}>
                    {({values, errors, touched, handleSubmit, handleChange, setFieldValue}) => {
                        return (
                            <form onSubmit={handleSubmit}>
                                <Grid container sx={{padding:'20px'}}>
                                    <Grid item container xs={12} spacing={2}>
                                        <Grid item xs={12} md={6}>
                                            <FormLabel>Código:</FormLabel>
                                            <TextField
                                                id="code"
                                                type="text" 
                                                name="code"
                                                fullWidth
                                                size="small"
                                                value={values.code}
                                                onChange={handleChange}
                                                error={errors.code && touched.code ? true : false}
                                                helperText={errors.code && touched.code ? errors.code : ''}
                                                inputProps={{ readOnly: action == 'detail' }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <FormLabel>Nombre:</FormLabel>
                                            <TextField
                                                id="name"
                                                type="text" 
                                                name="name"
                                                fullWidth
                                                size="small"
                                                value={values.name}
                                                onChange={handleChange}
                                                error={errors.name && touched.name ? true : false}
                                                helperText={errors.name && touched.name ? errors.name : ''}
                                                inputProps={{ readOnly: action == 'detail' }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <FormLabel>Descripción:</FormLabel>
                                            <TextField
                                                id="description"
                                                type="text" 
                                                name="description"
                                                fullWidth
                                                size="small"
                                                value={values.description}
                                                onChange={handleChange}
                                                error={errors.description && touched.description ? true : false}
                                                helperText={errors.description && touched.description ? errors.description : ''}
                                                inputProps={{ readOnly: action == 'detail' }}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Divider />
                                {
                                    action != 'detail' && (
                                        <ModalFooter 
                                            buttonType="submit"
                                            confirmText={'Guardar'}
                                            onConfirm={handleSubmit}
                                            cancelText={"Cancelar"}
                                            onCancel={closeModal}
                                            loadingConfirmText={loading}
                                            clearState={clearState}
                                        />
                                    )
                                }
                                
                            </form>
                        )
                    }} 
                </Formik>
            </ModalBody>
        </Modal>
    )
}